import ParameterContentManager from './redesign/ParameterContentManager';

// Integration Point for the new Redesigned Parameter Content Manager
// The legacy code has been moved to ParameterContentLegacy.js
const ParameterContent = (props) => {
    return <ParameterContentManager {...props} />;
};

export default ParameterContent;
